// @mui
import Box, { BoxProps } from '@mui/material/Box';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { useSettingsContext } from 'src/components/settings';
//
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  // Detect if Header renders the sub-tabs bar (see header.tsx `tabs` keys)
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const subBarRoots = [
    '/optimization/overview',
    '/optimization/conversions-analysis',
    '/optimization/funnel',
    '/optimization/traffic-details',
    '/optimization/activations/active-mode',
    '/optimization/activations/ko-bidding',
    '/optimization/activations/ko-bidding-auto',
    '/competitive-intelligence/overview',
    '/competitive-intelligence/competitive-landscape',
    '/competitive-intelligence/st-analysis',
    '/competitive-intelligence/ads',
  ];
  const hasHeaderSubBar = subBarRoots.some((root) => pathname.startsWith(root));
  const extraTopMobile = hasHeaderSubBar ? 56 : 0; // approximate height of subbar on mobile
  const extraTopDesktop = hasHeaderSubBar ? 64 : 0; // approximate height of subbar on desktop

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: `${HEADER.H_MOBILE + 24 + extraTopMobile}px`,
          pb: 10,
          ...(lgUp && {
            pt: `${HEADER.H_MOBILE * 2 + 40 + extraTopDesktop}px`,
            pb: 15,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        px: "24px",
        flexDirection: 'column',
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
